import { NavLink, Link } from 'react-router-dom';
import { IconCalendar, IconClock, IconHeart, IconImages, IconMoon, IconPin, IconSun } from './Icon';
import { initials, useSession } from '../lib/session';
import { toggleTheme, useTheme } from '../lib/theme';

const DESTS = [
  { to: '/now', label: 'Now', Icon: IconClock },
  { to: '/schedule', label: 'Schedule', Icon: IconCalendar },
  { to: '/map', label: 'Map', Icon: IconPin },
  { to: '/gallery', label: 'Photos', Icon: IconImages },
  { to: '/credits', label: 'Thanks', Icon: IconHeart },
];

/**
 * Sticky header: monogram, destinations, theme toggle, profile (D32).
 *
 * Five destinations rather than the four the requirements budgeted for —
 * Credits was promoted out of Profile. That is the whole reason the header CSS
 * has a 375px breakpoint: five labelled tabs stop fitting below it, so the
 * labels go and the icons stay.
 */
export default function Header() {
  const session = useSession();
  const { resolved } = useTheme();

  return (
    <header className="hdr">
      <Link className="hdr-brand" to="/now" aria-label="Meg and Videet — home">
        <span className="hdr-brand-short">M&amp;V</span>
      </Link>
      <nav className="hdr-dests" aria-label="Sections">
        {DESTS.map(({ to, label, Icon }) => (
          <NavLink key={to} to={to} className="hdr-dest">
            <Icon />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="hdr-right">
        <button
          type="button"
          className="hdr-icon-btn"
          onClick={toggleTheme}
          aria-label={resolved === 'dark' ? 'Switch to light' : 'Switch to dark'}
        >
          {resolved === 'dark' ? <IconMoon /> : <IconSun />}
        </button>
        <Link className="avatar" to="/me" aria-label="Your profile">
          {session ? initials(session.name) : '?'}
        </Link>
      </div>
    </header>
  );
}
